import { TreeOption } from 'ui/organizationsTreeSelect/OrganizationsTreeSelect.types';

export const findTreeOptionById = (tree: TreeOption[], id: string): TreeOption | null => {
  for (const node of tree) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findTreeOptionById(node.children, id);
      if (found) return found;
    }
  }
  return null;
};
